module.exports = __webpack_public_path__ + "img/model_43_ug.db10b860.jpg";